import axios from "../utils/axios";

// Get /roles/permission-groups
export const getAllRolesPermission = async () => {
    const { data } = await axios.get(`/roles/permission-groups`);
    return data;
};
// Get Roles
export const getAllRoles = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;

    const { data } = await axios.get(`/roles`, { params });
    return data;
};

// Get Roles
export const getRoles = async (id) => {
    // const { data } = await axios.get(`/roles?id=${id}`);
    const { data } = await axios.get(`/roles/${id}`);
    return data;
};

// Create Roles
export const createRoles = async (req) => {
    try {
        const { data } = await axios.post('/roles', req, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ createStore ~ error:", error);
        throw error;
    }
};

// update Roles
export const updateRoles = async (req, id) => {
    try {
        const { data } = await axios.put(`/roles/${id}`, req, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ updateStore ~ error:", error);
        throw error;
    }
};

// delete Roles
export const deleteRoles = async (id) => {
    try {
        const { data } = await axios.delete(`/roles/${id}`, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ deleteStore ~ error:", error);
        throw error;
    }
};